import { render, staticRenderFns } from "./PaymentsApp.vue?vue&type=template&id=443553b4"
import script from "./PaymentsApp.vue?vue&type=script&lang=js"
export * from "./PaymentsApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports